import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=5eac657e&scoped=true&"
import script from "./CollectionList.vue?vue&type=script&lang=js&"
export * from "./CollectionList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionList.vue?vue&type=style&index=0&id=5eac657e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eac657e",
  null
  
)

export default component.exports